'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CORPORATE_PARTNER_STORAGE_KEY = exports.CORPORATE_PARTNER_STORAGE_KEY = 'cpCorporatePartner';
var CORPORATE_PARTNER_JUSTWORKS = exports.CORPORATE_PARTNER_JUSTWORKS = 'justworks';
var CORPORATE_JUSTWORKS_REGEX = exports.CORPORATE_JUSTWORKS_REGEX = /^USA_\w*_JUSTWORKS\d*CREDITCORPORATEPLAN\d*_\d*_\d*_\w*_\d*CREDIT$/;